import * as React from 'react'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import Grid from '@mui/material/Grid'
import Link from '@mui/material/Link'

import { useOnboardingStore } from '../../stores/useOnboardingStore'

const DEFAULT_MESSAGE =
    'We are importing your data. Please, wait until this page reloads. The graph will be made available at'

/**
 * The "import in flight" step body shared by every import dialog: shown from
 * the moment the import POST goes out until the server responds with the
 * redirect to the new graph.
 *
 * It is also the onboarding hook: for a first-session user still at the
 * bring-data stage, mounting this notice starts the narrated-build overlay
 * (rendered by OnboardingGuide above the dialog) so the narration covers
 * submit → reload → graph ready as one sequence. The effect cleanup only
 * runs when the dialog closes or the import errors out before the redirect —
 * a successful import replaces the whole page without unmounting, so the
 * narration and its persisted clock survive into the next page load.
 */
export default function ImportingNotice({
    linkHref,
    message = DEFAULT_MESSAGE,
    linkLabel = 'this page',
}) {
    React.useEffect(() => {
        const onboardingStore = useOnboardingStore.getState()
        if (
            onboardingStore.status !== 'active' ||
            onboardingStore.stage !== 'bring'
        ) {
            return
        }
        onboardingStore.startImportNarration()
        return () => useOnboardingStore.getState().cancelImportNarration()
    }, [])

    return (
        <DialogContent
            sx={{
                paddingRight: 4,
                paddingLeft: 4,
                paddingTop: 4,
            }}
        >
            <Grid container spacing={8}>
                <Grid item xs={12} sm={5}>
                    <DialogContentText>
                        <img src="/images/loading-icon.svg" />
                        <br />
                        <br />
                        {message}{' '}
                        <Link href={linkHref} underline="hover">
                            {linkLabel}
                        </Link>
                    </DialogContentText>
                </Grid>
            </Grid>
        </DialogContent>
    )
}
